












import { Component, Vue } from 'vue-property-decorator';
import i18n from '@/i18n';

@Component({})
export default class MainNavigation extends Vue {
  private get navigation(): object[] {
    return this.$config.navigation.header;
  }
}
